import { alias } from '@ember/object/computed';

import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  name: validator('presence', true),
});

export default class LocationModel extends Model.extend(Validations) {
  @attr('string') city;
  @attr('string') name;
  @attr('string') street;
  @attr('string') zip;

  // CMS fields
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Getter, setter and computed properties
  @alias('name') displayHeadline;

  get displayLabel() {
    return `${this.name} (${this.city})`;
  }
}
